import { useTranslation } from 'react-i18next';
import { backgrounds } from '@/assets/piecrip/images';
import PiecripHeader from '@/app/components/Piecrip/Header';
import * as S from './styles';
import { useIsMobile } from '@/utils/CalVW';
import { useMissionTotalRewards } from '@/app/hooks/trade/tradeMission';
import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';

// Local assets
import planetsImg from '@/assets/images/reward-page/planets.svg';
import astronautImg from '@/assets/images/reward-page/astronaut.svg';
import rocketImg from '@/assets/images/reward-page/rocket.svg';
import checkInIconImg from '@/assets/images/reward-page/check-in-icon.svg';
import myRewardsIconImg from '@/assets/images/reward-page/my-rewards-icon.svg';
import shareIconImg from '@/assets/images/reward-page/share-icon.svg';

const RewardHeader = () => {
  const [displayAmount, setDisplayAmount] = useState(0);
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  // 총 보상금액 조회 API 사용: /v1/missions/total-rewards (모든 카테고리)
  const { data } = useMissionTotalRewards();

  const sumAmount = data?.totalRewards ?? 120;

  useEffect(() => {
    if (sumAmount <= 0) return;

    const targetAmount = sumAmount;
    const duration = 1000;
    const steps = 30;
    const increment = targetAmount / steps;
    let current = 0;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      current += increment;
      if (step >= steps) {
        setDisplayAmount(targetAmount);
        clearInterval(timer);
      } else {
        setDisplayAmount(Number(current.toFixed(0)));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [sumAmount]);

  return (
    <S.HeroContainer>
      <PiecripHeader transparent activeMenu="Earn" />
      
      {/* Background */}
      <S.Background />
      
      {/* Planets Background */}
      <S.PlanetsBg>
        <img src={planetsImg} alt="planets" />
      </S.PlanetsBg>

      {/* Astronaut Illustration */}
      <S.AstronautIllustration>
        <img src={astronautImg} alt="astronaut" />
      </S.AstronautIllustration>

      {/* Rocket Icon */}
      <S.RocketIcon>
        <img src={rocketImg} alt="rocket" />
      </S.RocketIcon>

      {/* Content */}
      <S.ContentWrapper>
        <S.LeftSection>
          <S.Title>Piecrip Rewards Hub</S.Title>
          <S.Description>
            Discover starter bonuses designed to help you begin your trading journey on Piecrip.
          </S.Description>
          <S.TotalRewards>
            Total rewards available: <S.RewardsHighlight>UP TO {displayAmount} USDT!</S.RewardsHighlight>
          </S.TotalRewards>
        </S.LeftSection>

        <S.ButtonGroup>
          <S.PrimaryButton>
            <S.CheckInIcon>
              <img src={checkInIconImg} alt="check-in" />
            </S.CheckInIcon>
            <span>Check-In</span>
          </S.PrimaryButton>

          <S.SecondaryButton>
            <S.MyRewardsIcon>
              <img src={myRewardsIconImg} alt="my-rewards" />
            </S.MyRewardsIcon>
            <span>My Rewards</span>
          </S.SecondaryButton>

          <S.SecondaryButton>
            <S.ShareIcon>
              <img src={shareIconImg} alt="share" />
            </S.ShareIcon>
            <span>Share</span>
          </S.SecondaryButton>
        </S.ButtonGroup>
      </S.ContentWrapper>
    </S.HeroContainer>
  );
};

export default RewardHeader;
